const Spinner = ({ color, size }: { color: 'blue' | 'white' | 'primary'; size?: 'large' }) => {
    const borderColor =
        color === 'blue'
            ? 'border-blue'
            : color === 'white'
              ? 'border-white'
              : color === 'primary'
                ? 'border-primary'
                : 'border-gray-disabled';
    const radius = size === 'large' ? 'h-24 w-24 border-[4px]' : 'h-4 w-4 border-[3px]';
    return (
        <i
            className={`${radius} inline-block ${borderColor} rounded-full border-l-transparent align-middle animate-spin mx-auto`}
        />
    );
};

export default Spinner;
